import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Container } from '../../layout/Container'
import { Button } from '../../ui/Button'
import { ArrowRight } from 'lucide-react'
import { useScrollAnimation } from '../../../hooks/useScrollAnimation'

export function PlatformCTA() {
  const { t } = useTranslation()
  const { ref, isInView } = useScrollAnimation()

  return (
    <section ref={ref} className="py-24">
      <Container size="narrow">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="relative overflow-hidden rounded-3xl border border-border-subtle bg-surface-elevated px-6 py-16 text-center sm:px-12"
        >
          <div className="absolute inset-0 bg-gradient-to-br from-accent/10 via-transparent to-accent-light/5" />
          <div className="relative z-10">
            <span className="text-sm font-medium uppercase tracking-wider text-accent-light">
              {t('platformPages.common.ctaLabel')}
            </span>
            <h2 className="mt-4 text-3xl font-semibold tracking-tight text-text-primary sm:text-4xl">
              {t('platformPages.common.ctaTitle')}
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-text-secondary">
              {t('platformPages.common.ctaDescription')}
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
              <Button asChild size="lg">
                <a href="/#diagnostico" className="group">
                  {t('platformPages.common.ctaPrimary')}
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </a>
              </Button>
              <Button asChild variant="outline" size="lg">
                <a href="/#sistema">{t('platformPages.common.ctaSecondary')}</a>
              </Button>
            </div>
          </div>
        </motion.div>
      </Container>
    </section>
  )
}
